import * as z from 'zod/mini';
export const ActorResponseStatus = z.union([
    z.literal(200),
    z.literal(400),
    z.literal(403),
    z.literal(404),
    z.literal(408),
    z.literal(500),
    z.literal(503),
]);
/**
 * Response from gateway to client (gateway -> client).
 * Sent after RPC request is processed by the actor.
 */
export const ActorResponse = z.object({
    /** Message type identifier. */
    type: z.literal('RES'),
    /** Request ID for correlation. */
    id: z.string(),
    /** Response status. */
    status: ActorResponseStatus,
    /** Response data (present when status is 200). */
    data: z.optional(z.unknown()),
    /** Error message (present when status is not 200). */
    error: z.optional(z.string()),
    /** Server timestamp. */
    ts: z.number(),
    /** Node ID that handled the request. */
    hostId: z.string(),
});
//# sourceMappingURL=ActorResponse.js.map